module.exports = __webpack_public_path__ + "img/PT515570486.b3655f5c.png";